import React from "react";
import CM_Foundation_Stone from "./../../assets/CM Foundation Stone.svg";

export const CmFoundationStone = ({ className, isValidProject }) => {
  return isValidProject ? (
    <div className={className}>
      <img src={CM_Foundation_Stone} />
    </div>
  ) : null;
};
